// extracted by mini-css-extract-plugin
module.exports = {"InputContainer":"About_InputContainer__1iAiP","PostForm":"About_PostForm__2Zf9-","AboutInput":"About_AboutInput__3rmPe","ShortWindow":"About_ShortWindow__3OBZw"};